module.exports = __webpack_public_path__ + "static/media/5.bbdd625d.svg";